module.exports = __webpack_public_path__ + "static/img/Flynn-Penry.7102113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Flynn-Penry.jpg
// module id = aXme
// module chunks = 0